import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, API_CONSTANTS, APP_CONSTANTS } from '../../global/Constants';
import './otp.css';
import { LOGO, LOGIN_SIDE_IMAGE } from '../../global/Icons';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import Loader from '../common/loader/Loader';
import AuthService from '../../providers/AuthService';

const otpTimer = 60;
class OtpPage extends Component {


    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            errorMsg: "",
            loading: false,
            isForgot: false,
            token: null,
            fields: {
                digit1: "",
                digit2: "",
                digit3: "",
                digit4: "",
            },
            time: {},
            seconds: otpTimer,
        }
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidMount() {
        document.getElementById("continue").disabled = true;
        this.startTimer();
        const { isForgot } = (this.props.location && this.props.location.state) || {};
        const { token } = (this.props.location && this.props.location.state) || {};
        this.setState({ isForgot, token });
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
        }
    }

    _performResendOTP = () => {
        this.setState({ loading: true });
        const { email } = (this.props.location && this.props.location.state) || {};
        var body = JSON.stringify({
            userId: email,
            isLoginOtp: true,
        });
        try {
            ApiServices.logIn(body)
                .then(response => {
                    this.setState({ loading: false });
                    var status = response.success;
                    if (status) {
                        this.props.history.push({
                            pathname: ALL_ROUTES.OTP_ROUTE,
                            state: { email: email, isForgot: this.state.isForgot, token: response.data.token }
                        })
                    } else {
                        this.setState({
                            errorMsg: response.message
                        });
                    }
                }).catch(error => {
                    this.setState({ loading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ loading: false, errorMsg: error });
        }
    }

    resendOtp = () => {
        this.timer = 0;
        this.setState({ seconds: otpTimer }, () => {
            this.startTimer();
        });
        this._performResendOTP();
    }

    _handleVerifyOTP = (e) => {
        this.setState({ loading: true });
        e.preventDefault();
        const digit1 = this._getFieldValue("digit1", "");
        const digit2 = this._getFieldValue("digit2", "");
        const digit3 = this._getFieldValue("digit3", "");
        const digit4 = this._getFieldValue("digit4", "");
        var verifyOTPBody = JSON.stringify({
            otp: digit1 + digit2 + digit3 + digit4,
        });
        Utilities.LogPrint("Body", verifyOTPBody);

        try {
            ApiServices.verifyUserOtp(verifyOTPBody, this.state.token)
                .then(response => {
                    this.setState({ loading: false });
                    var status = response.success;
                    if (status) {
                        //localStorage.setItem(API_CONSTANTS.ACCESS_TOKEN, "Bearer " + response.data.token);
                        AuthService.setSession(APP_CONSTANTS.APP_USER, response.data);

                        if (this.state.isForgot) {
                            this.props.history.replace(ALL_ROUTES.SET_NEW_PASSWORD_ROUTE);
                        } else {
                            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                        }

                    } else {
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ loading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ loading: false, errorMsg: error });
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || (typeof value === 'undefined')) {
            value = defaultValue;
        }
        return value;
    }

    handleChange(e, ref, field) {
        e.preventDefault();
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields })
        const digit1 = this._getFieldValue("digit1", "");
        const digit2 = this._getFieldValue("digit2", "");
        const digit3 = this._getFieldValue("digit3", "");
        const digit4 = this._getFieldValue("digit4", "");
        if (digit1 === "" || digit2 === "" || digit3 === "" || digit4 === "") {
            document.getElementById("continue").disabled = true;
        } else {
            document.getElementById("continue").disabled = false;
        }
        if (ref !== this.myInp1) {
            ref.focus();
        }
    }

    renderTimer = () => {
        if (this.state.seconds === 0) {
            //clearInterval(this.timer);
            return (
                <p>OTP not received?
                    <span className="otp-resend-enable" onClick={this.resendOtp}> Resend </span>
                </p>
            );
        } else {
            return (
                <p>OTP not received?
                    <span className="otp-resend-disable"> Resend </span>
                    ({this.state.time.s} secs)
                </p>
            );
        }
    }

    render() {
        const { errorMsg, loading } = this.state;
        const digit1 = this._getFieldValue("digit1", "");
        const digit2 = this._getFieldValue("digit2", "");
        const digit3 = this._getFieldValue("digit3", "");
        const digit4 = this._getFieldValue("digit4", "");
        const { email } = (this.props.location && this.props.location.state) || {};

        return (
            <div className="sign-page">
                <div className="row mx-auto">
                    <div className="col-md-6 col-12 homeimg pr-5">

                        <img src={LOGIN_SIDE_IMAGE} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-6 col-12 pl-md-0 pr-md-5">
                        <div className="row">
                            <div className="col-12 signin-max-489">

                                <div className="logo">
                                    <i class="customic ic-back-button mb-3" onClick={() => this.goBack()}></i><br />
                                    <img src={LOGO} className="img-fluid" alt="" />
                                </div>

                                <h5>Enter OTP sent on {email}</h5>
                                <form action="">
                                    <div className="form-group otp-input mt-md-3">
                                        <input type="text" className="form-control" placeholder="-" maxLength="1" ref={(ip) => this.myInp1 = ip} onChange={(e) => { this.handleChange(e, this.myInp2, "digit1") }} value={digit1} />
                                        <input type="text" className="form-control" placeholder="-" maxLength="1" ref={(ip) => this.myInp2 = ip} onChange={(e) => { this.handleChange(e, this.myInp3, "digit2") }} value={digit2} />
                                        <input type="text" className="form-control" placeholder="-" maxLength="1" ref={(ip) => this.myInp3 = ip} onChange={(e) => { this.handleChange(e, this.myInp4, "digit3") }} value={digit3} />
                                        <input type="text" className="form-control" placeholder="-" maxLength="1" ref={(ip) => this.myInp4 = ip} onChange={(e) => { this.handleChange(e, this.myInp1, "digit4") }} value={digit4} />
                                    </div>

                                    <p class="info-paragraph">Enter mobile number / email address registered with us.</p>
                                    <span
                                        className={
                                            errorMsg.length > 0 ? "error-msg" : "d-none error-msg"
                                        }
                                    >
                                        {errorMsg}
                                    </span>
                                    <button id="continue" className="btn btn-primary w-100 mb-2 mt-md-3" onClick={this._handleVerifyOTP}>CONTINUE</button>
                                    {this.renderTimer()}

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <Loader /> : null}
            </div>
        )
    }
}

export default withRouter(OtpPage)